module.exports = __webpack_public_path__ + "static/015-c500e38c2615ab930980c85ccacc1498.jpg";